// extracted by mini-css-extract-plugin
export default {"CountriesFeature":"wq_a bii_b"};